import { useCallback, useState } from "react";
import { AssetFormState, EMPTY_ASSET_FORM } from "../utils/assetEntity";

/** The editor's form values as one object; `reset` replaces all of them at once. */
export function useAssetForm() {
  const [form, setForm] = useState<AssetFormState>(EMPTY_ASSET_FORM);

  const setField = useCallback(<K extends keyof AssetFormState>(key: K, value: AssetFormState[K]) => {
    setForm(previous => ({ ...previous, [key]: value }));
  }, []);

  const reset = useCallback((next: AssetFormState = EMPTY_ASSET_FORM) => setForm(next), []);

  return { form, setField, reset };
}
